<template>
  <svg
    id="Log-Out-Door--Streamline-Nova"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height="24"
    width="24"
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M10.6257 0.219967c0.2366 0.189796 0.3743 0.476722 0.3743 0.780043V23c0 0.3033 -0.1377 0.5903 -0.3743 0.7801 -0.2366 0.1897 -0.5465 0.2619 -0.84263 0.1961l-9 -2C0.325532 21.8745 0 21.4687 0 21V3.00001c0 -0.4687 0.325532 -0.87451 0.78307 -0.97619l9 -1.9999981c0.29613 -0.0657993 0.60603 0.0063496 0.84263 0.1961451ZM13 4h5v9h2V3c0 -0.55228 -0.4477 -1 -1 -1h-6v2Zm-0.6001 16h8.1859l-2.293 2.2929 1.4143 1.4142 4 -4c0.3905 -0.3905 0.3905 -1.0237 0 -1.4142l-4 -4 -1.4143 1.4142L20.5857 18h-8.1858v2Zm-4.89966 -8c0 0.6627 -0.53745 1.2001 -1.20019 1.2001 -0.66274 0 -1.19995 -0.5374 -1.19995 -1.2001s0.53721 -1.2 1.19995 -1.2c0.66274 0 1.20019 0.5373 1.20019 1.2Z"
      clip-rule="evenodd"
      stroke-width="1"
    ></path>
  </svg>
</template>
